<div *ngIf="isOpen" class="vf-acm-overlay" (click)="$event.target === $event.currentTarget && close()">
  <div style="background:#fff; border-radius:6px; width:512px; display:flex; flex-direction:column; overflow:hidden; box-shadow:0 20px 60px rgba(0,0,0,0.2); border: 2px solid #d1d5db; position: relative;"
    (click)="$event.stopPropagation()">

    <!-- Close button (absolute) -->
    <button type="button"
      class="d-inline-flex align-items-center justify-content-center text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors"
      style="position:absolute; top:16px; right:20px; width:28px; height:28px; background:transparent; border:none; border-radius:6px; z-index:1;"
      (click)="close()">
      <lucide-icon name="x" [size]="16" [strokeWidth]="2"></lucide-icon>
    </button>

    <!-- Header -->
    <div class="px-20 flex-shrink-0" style="padding-top: 14px; padding-bottom: 14px; border-bottom: 1px solid #e5e7eb;">
      <div style="min-width: 0; padding-right: 32px;">
        <h3 class="f-size-14 font-weight-semibold text-gray-900 mb-0" style="line-height: 1.4;">Select storage location</h3>
        <p class="f-size-12 text-gray-500 mb-0" style="line-height: 1.4; margin-top: 2px;">
          Choose a SharePoint site where client documents will be stored
        </p>
      </div>
    </div>

    <!-- Search -->
    <div class="px-20 flex-shrink-0" style="padding-top: 16px; padding-bottom: 12px;">
      <div style="position: relative;">
        <lucide-icon name="search" [size]="16" [strokeWidth]="2"
          class="text-gray-400"
          style="position:absolute; left:10px; top:50%; transform:translateY(-50%); pointer-events:none;">
        </lucide-icon>
        <input type="text" class="f-size-13 text-gray-700 vf-sp-search-input"
          style="width:100%; padding: 10px 12px 10px 34px; background:#f3f4f6; border:1px solid transparent; border-radius:6px; outline:none;"
          placeholder="Search SharePoint sites..."
          [(ngModel)]="searchText"
          (ngModelChange)="onSearch()"
          autocomplete="off">
      </div>
    </div>

    <!-- Site List -->
    <div class="px-2 pb-8" style="overflow-y: auto; max-height: 320px;">

      <!-- Loading skeleton -->
      <ng-container *ngIf="isLoading">
        <div *ngFor="let i of [1,2,3,4]"
          class="d-flex align-items-center gap-12 px-12 py-12 mb-2 rounded-6"
          style="background: #f9fafb;">
          <div style="width:32px; height:32px; background:#e5e7eb; border-radius:6px; flex-shrink:0;"></div>
          <div class="flex-1">
            <div style="height:11px; background:#e5e7eb; border-radius:6px; width:55%; margin-bottom:6px;"></div>
            <div style="height:10px; background:#e5e7eb; border-radius:6px; width:75%;"></div>
          </div>
        </div>
      </ng-container>

      <!-- Empty state -->
      <div *ngIf="!isLoading && filteredSites.length === 0"
        class="d-flex flex-column align-items-center justify-content-center py-32 text-center">
        <lucide-icon name="globe" [size]="28" [strokeWidth]="1.5" class="text-gray-300 mb-8"></lucide-icon>
        <p class="f-size-13 text-gray-400 mb-0">
          {{ searchText ? 'No sites match your search' : 'No SharePoint sites found' }}
        </p>
      </div>

      <!-- Sites -->
      <ng-container *ngIf="!isLoading && filteredSites.length > 0">
        <button *ngFor="let site of filteredSites" type="button"
          class="w-100 d-flex align-items-center gap-12 px-12 py-12 transition-colors text-left"
          style="border:none; border-radius:6px; cursor:pointer;"
          [style.background]="selectedSite?.id === site.id ? '#eff6ff' : 'transparent'"
          [style.box-shadow]="selectedSite?.id === site.id ? 'inset 2px 0 0 #2563eb' : 'none'"
          (mouseenter)="!selectedSite || selectedSite.id !== site.id ? ($event.currentTarget['style'].background='#f9fafb') : null"
          (mouseleave)="!selectedSite || selectedSite.id !== site.id ? ($event.currentTarget['style'].background='transparent') : null"
          (click)="selectSite(site)">
          <!-- Globe icon -->
          <div class="d-flex align-items-center justify-content-center flex-shrink-0"
            style="width:32px; height:32px; background:#f3f4f6; border-radius:6px;">
            <lucide-icon name="globe" [size]="16" [strokeWidth]="2" class="text-gray-500"></lucide-icon>
          </div>
          <!-- Site info -->
          <div class="flex-1 text-left" style="min-width:0;">
            <p class="f-size-14 text-gray-900 mb-0 text-truncate" style="line-height:1.4;">{{site.displayName}}</p>
            <p class="f-size-12 text-gray-500 mb-0 text-truncate" style="line-height:1.4; margin-top:2px;">{{site.webUrl}}</p>
          </div>
          <!-- Checkmark (filled blue circle) -->
          <div *ngIf="selectedSite?.id === site.id"
            class="d-flex align-items-center justify-content-center flex-shrink-0"
            style="width:20px; height:20px; background:#2563eb; border-radius:50%;">
            <lucide-icon name="check" [size]="12" [strokeWidth]="3" class="text-white"></lucide-icon>
          </div>
        </button>
      </ng-container>
    </div>

    <!-- Error -->
    <div *ngIf="errorMessage" class="px-20 py-8 flex-shrink-0"
      style="background:#fef2f2; border-top:1px solid #fecaca;">
      <span class="f-size-13 text-danger">{{errorMessage}}</span>
    </div>

    <!-- Footer -->
    <div class="d-flex align-items-center justify-content-end gap-8 px-20 flex-shrink-0"
      style="padding-top:12px; padding-bottom:12px; border-top:1px solid #e5e7eb;">
      <button type="button"
        class="btn f-size-13 font-weight-medium rounded-6 px-16 hover:bg-gray-100"
        style="height:34px; background:transparent; border:none; color:#374151;"
        (click)="close()">
        Cancel
      </button>
      <button type="button"
        class="d-inline-flex align-items-center f-size-13 font-weight-medium rounded-6 px-16"
        style="height:34px; background:#111827; color:#fff; border:none; cursor:pointer;"
        [class.opacity-50]="!selectedSite || isSaving"
        [disabled]="!selectedSite || isSaving"
        (click)="setAsDefault()">
        <span *ngIf="isSaving" class="spinner-border spinner-border-sm mr-8" style="width:13px; height:13px; border-width:2px;"></span>
        {{ isSaving ? 'Saving...' : 'Set as default' }}
      </button>
    </div>

  </div>
</div>
